(function () {
  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getVisibleSlides(slider) {
    return Array.from(slider.querySelectorAll('.product__media-item')).filter(function (slide) {
      return slide.offsetWidth > 0 && getComputedStyle(slide).display !== 'none';
    });
  }

  function getNearestIndex(slider, slides) {
    var scrollLeft = slider.scrollLeft;
    var index = 0;
    var best = Infinity;
    slides.forEach(function (slide, i) {
      var distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < best) {
        best = distance;
        index = i;
      }
    });
    return index;
  }

  function syncGallery(gallery, slider, slide) {
    if (!slide) return;
    var mediaId = slide.getAttribute('data-media-id');
    if (!mediaId) return;

    slider.querySelectorAll('.product__media-item').forEach(function (item) {
      item.classList.toggle('is-active', item === slide);
    });

    var thumb = gallery.querySelector('[data-target="' + mediaId + '"] button');
    if (thumb) {
      gallery.querySelectorAll('[data-target] button').forEach(function (button) {
        button.removeAttribute('aria-current');
      });
      thumb.setAttribute('aria-current', 'true');
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function goToIndex(gallery, slider, slides, index) {
    if (!slides.length) return;
    var nextIndex = Math.max(0, Math.min(slides.length - 1, index));
    var slide = slides[nextIndex];
    slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    syncGallery(gallery, slider, slide);
  }

  function initGallerySwipe(root) {
    var scope = root || document;
    scope.querySelectorAll('media-gallery').forEach(function (gallery) {
      var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      var slider = viewer && viewer.querySelector('[id^="Slider-Gallery-"]');
      if (!slider || slider.dataset.swipeInit === 'true') return;
      slider.dataset.swipeInit = 'true';

      var touchStartX = 0;
      var touchStartY = 0;
      var touchAxis = null;
      var tracking = false;

      slider.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchAxis = null;
          tracking = true;
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchmove',
        function (event) {
          if (!tracking || event.touches.length !== 1 || touchAxis) return;

          var deltaX = Math.abs(event.touches[0].clientX - touchStartX);
          var deltaY = Math.abs(event.touches[0].clientY - touchStartY);
          if (deltaX < 8 && deltaY < 8) return;

          touchAxis = deltaX > deltaY ? 'x' : 'y';
          if (touchAxis === 'y') {
            tracking = false;
          }
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchend',
        function (event) {
          if (!tracking) return;
          tracking = false;

          if (touchAxis === 'y') return;

          var touch = event.changedTouches[0];
          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;
          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;

          var slides = getVisibleSlides(slider);
          if (slides.length < 2) return;

          var currentIndex = getNearestIndex(slider, slides);
          if (deltaX < 0) {
            goToIndex(gallery, slider, slides, currentIndex + 1);
          } else {
            goToIndex(gallery, slider, slides, currentIndex - 1);
          }
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchcancel',
        function () {
          tracking = false;
          touchAxis = null;
        },
        { passive: true }
      );

      if (!isMobile()) {
        slider.addEventListener(
          'scroll',
          debounce(function () {
            var slides = getVisibleSlides(slider);
            if (!slides.length) return;
            syncGallery(gallery, slider, slides[getNearestIndex(slider, slides)]);
          }, 120)
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGallerySwipe();
    });
  } else {
    initGallerySwipe();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initGallerySwipe(event.target);
  });

  window.initProductGallerySwipe = initGallerySwipe;
})();
